/**
 * Meta Pixel (id 1749956882712100) — installed once, globally.
 *
 * This project has no editable index.html, so the official base code is
 * injected verbatim into <head> at runtime. The guards below ensure the
 * script and the PageView event are never duplicated, even across
 * re-renders, route changes or hot reloads.
 */

const PIXEL_ID = '1749956882712100'
const MARKER = 'data-meta-pixel'

const BASE_CODE = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${PIXEL_ID}');
fbq('track', 'PageView');`

export function installMetaPixel(): void {
  if (typeof document === 'undefined') return
  if (document.querySelector(`script[${MARKER}]`)) return

  const script = document.createElement('script')
  script.setAttribute(MARKER, 'base-code')
  script.text = BASE_CODE
  document.head.appendChild(script)

  const noscript = document.createElement('noscript')
  noscript.setAttribute(MARKER, 'noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.alt = ''
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.head.appendChild(noscript)
}
